module.exports = __webpack_public_path__ + "img/a1c13d535a4a1e428f9f4202986b5ce1.bd544759.png";